<template>
  <div class="report-reason">
    <z-fix-top
      keep-position
      class="fixtop"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          title="我的举报记录"
          @click-left="closePage"
      ></z-nav-bar>
    </z-fix-top>
    <z-list
      v-if="!showStance"
      ref="zlist"
      v-model="loading"
      :finished="finished"
      @load="getReportList"
      :finished-text="finishedText"
     >
    <div class="card-container" v-for="(item,index) in reasonList" :key="index">
      <info-card
        :infoData="item"
      ></info-card>
    </div>
    </z-list>
    <z-stance v-if="showStance" :show-btn="false" :show-info="false" descText="还没举报过哦～" type="general"></z-stance>
  </div>
</template>

<script>
import { List, NavBar, FixTop, Stance } from '@zz-common/zz-ui'
import InfoCard from './InfoCard'
import native from '@zz-common/native-adapter'
import { getreporthistorys } from '@api/resourceApi'

export default {
  name: 'ReportList',
  data() {
    return {
      reasonList: [], //列表
      pageNo: 1, //分页
      loading: false, //加载中
      finished: false, //没有更多数据
      finishedText: '到底了',
      showStance: false,
      native
    }
  },
  components: {
    InfoCard,
    zList: List,
    'z-fix-top': FixTop,
    'z-nav-bar': NavBar,
    'z-stance': Stance
  },
  methods: {
    closePage() {
      native.close()
    },
    async getReportList() {
      const res = await getreporthistorys({ pageNo: this.pageNo++ })
      console.log(res)
      this.loading = false
      if (!res.length) {
        if (this.$refs.zlist.$el.scrollHeight == this.$refs.zlist.$el.clientHeight) {
          this.finishedText = ''
        }
        if (!this.reasonList.length) {
          this.showStance = true
        }
        this.finished = true
      } else {
        this.reasonList = this.reasonList.concat(res)
      }
    }
  }
}
</script>

<style scoped lang="less">
  @import 'ReportList.less';
</style>
